import { Stack } from "@mantine/core"
import { LabelWithTooltip, Switch } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/form.types"
import { errorCodes } from "~/pages/SupplierPortal/TraceabilityRequests/components/ZodCustomErrorMap"

export const SwitchField = (
  fields: FormFieldConfig,
  form: any,
  error: keyof errorCodes | undefined,
  translations: errorCodes | undefined
) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {fields.tooltip && (
      <LabelWithTooltip
        label={fields.label}
        hoverHelperText={fields.tooltip}
        justify={fields.tooltipJustify ?? "space-between"}
        fw={600}
        withAsterisk={fields.required ?? false}
      />
    )}
    <Switch
      key={fields.name}
      label={!fields.tooltip ? fields.label : undefined}
      {...form.getInputProps(fields.name, { type: "checkbox" })}
      size="xs"
      classNames={fields.customClass}
      defaultChecked={fields.defaultChecked}
      error={
        (error && translations?.[error]) ||
        (!form.isValid(fields.name) && form.isTouched(fields.name))
      }
      disabled={fields.disabled}
    />
  </Stack>
)
